<template>
    <activation-preview-provider
        v-slot="{
            brief,
            step,
            affiliateLinks,
            discountCodes,
        }"
        :module-name="moduleName"
    >
        <activation-brief-payments-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :affiliate-links="affiliateLinks"
            :discount-codes="discountCodes"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefPaymentsView from '../../data-views/activation-briefs/ActivationBriefPaymentsView';
    import PageMask from '../../library/PageMask';
    import {NAME_COMPENSATION} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationPaymentsPreviewRouterView',
        components: {
            ActivationBriefPaymentsView,
            ActivationPreviewProvider,
            PageMask,
        },
        data(){
            return {
                moduleName: NAME_COMPENSATION,
            };
        },
    };
</script>
